<div class="">
    <div class="row form-cat in-overlay">
        <div class="col-sm-4 m-auto">
            <form #refFC="ngForm" (ngSubmit)="submitFormCat(refFC)">
                <div class="form-group">
                    <label for="title">Title</label>
                    <input [(ngModel)]="title" id="title" name="title" class="form-control">
                </div>
                <div class="form-group">
                    <label for="desc">Description:</label>
                    <input [(ngModel)]="description" id="desc" name="description" class="form-control">
                </div>
                <div class="btn-wrap">
                    <button [disabled]="!title" class="btn btn-primary col-sm-5">Save</button>
                    <button type="button" (click)="cancel()" class="btn btn-danger col-sm-5">cancel</button>
                </div>            
            </form>
        </div>
    </div>
</div>